module.exports = __webpack_public_path__ + "static/media/tavatar-rachel.2cb017e9.jpg";